import { ref, watch } from 'vue'

import { requestNewsFilteredTrending } from '@/api/news'
import getRequestAPIResult from '@/modules/shared/composables/useRequestAPIResult'

export default function useGetStatementdogNewsDataV2({ ticker }) {
  const newsList = ref([])
  const pagination = ref({
    currentPage: 0,
    totalPages: 1,
  })

  const {
    result,
    isLoading,
    hasLoadingError,
    requestAPIData,
  } = getRequestAPIResult({
    requestAPI: () => requestNewsFilteredTrending({
      ticker,
      page: pagination.value.currentPage + 1,
    }),
  })

  watch(
    () => result.value,
    (newResult) => {
      if (newResult === null) {
        return
      }

      newsList.value = [
        ...newsList.value,
        ...newResult.data?.news_list || [],
      ]
      pagination.value = {
        currentPage: newResult.data?.pagination.current_page || 1,
        totalPages: newResult.data?.pagination.total_pages || 1,
      }
    },
  )

  const resetStatementdogNews = () => {
    newsList.value = []
    pagination.value = {
      currentPage: 0,
      totalPages: 1,
    }
  }

  return {
    isLoadingStatementdogNews: isLoading,
    hasLoadingStatementdogNewsError: hasLoadingError,
    newsList,
    pagination,
    getStatementdogNewsData: requestAPIData,
    resetStatementdogNews,
  }
}
